import { useNotificationSocketEvents } from "@/features/engagement/hooks/useNotificationSocketEvents";
import { useSocketConnection } from "@/features/messaging/hooks/useSocketConnection";

/**
 * Renders nothing — exists only to call the app-wide socket hooks from
 * inside `App.tsx`'s component tree, where Redux/Router/Query context is
 * available. Lives here (not inside one feature's own folder) because it
 * aggregates listeners for more than one feature (messaging's connection
 * lifecycle, engagement's `new_notification` handling) — a notification
 * needs to reach the user no matter which page they're on, not just while
 * they're inside `features/messaging`'s routes.
 */
export function SocketConnectionManager() {
  useSocketConnection();
  useNotificationSocketEvents();
  return null;
}
